export default __webpack_public_path__ + "static/media/omr.a61d26bf.png";